// removed by extract-text-webpack-plugin
module.exports = {"multiline":"_2xOGhbjgvp1GdCZTmr1a7y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MultiLine/MultiLine.scss
// module id = 1088
// module chunks = 0